const isOneColConfigurator = ({ configurations  })=>configurations.configuratorType === 'one-column'
;

export { isOneColConfigurator };
//# sourceMappingURL=typeguards.js.map
